import { render } from "./component-subtitle-adress-details.vue?vue&type=template&id=90862fc8"
import script from "./component-subtitle-adress-details.vue?vue&type=script&setup=true&lang=js"
export * from "./component-subtitle-adress-details.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-subtitle-adress-details.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "90862fc8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('90862fc8', __exports__)) {
    api.reload('90862fc8', __exports__)
  }
  
  module.hot.accept("./component-subtitle-adress-details.vue?vue&type=template&id=90862fc8", () => {
    api.rerender('90862fc8', render)
  })

}


export default __exports__